import { environment } from 'environments';

(() => {
  class QuestionController {
    constructor($scope, $timeout, toastr, Utils) {
      'ngInject';

      Object.assign(this, {
        $scope,
        $timeout,
        toastr,
        Utils,
        BOD_557_feature_flag: ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV),
        LMNUK_1695: ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV),
        BOD_1144: ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV),
        LMNUK_1234: ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV), //New ticket is BOD_608...
        BOD_2690: [].includes(environment.constants.ENV),
      });

      $timeout(() => {
        $('.checkboxLayer').css('width', '100%');
      });

      $scope.ngDialogData.statusTypes = [
        'text',
        'select',
        'select_combo',
        'date',
        'date_hidden',
        'gp_address',
        'gp_address_csv',
        ...(FEATURE_BODACDC_2929 ? ['gp_address_docman'] : []),
        'blood_pressure',
        'blood_pressure_uk',
        'bmi',
        'bmi_weight',
        'fast_track',
        'bmi_cocp_nor',
        'bmi_pde_pro',
        'bmi_map_lev1',
        'bmi_map_lev2',
        'bmi_map_uli',
        'bmi_wei',
        'bmi_meno',
        'bmi_wei_r',
        'info',
      ];
      if (!this.BOD_557_feature_flag)
        $scope.ngDialogData.statusTypes.splice($scope.ngDialogData.statusTypes.indexOf('blood_pressure_uk'), 1);
      if (!this.LMNUK_1695)
        $scope.ngDialogData.statusTypes.splice($scope.ngDialogData.statusTypes.indexOf('select_combo'), 1);
      if (!this.BOD_1144) $scope.ngDialogData.statusTypes.splice($scope.ngDialogData.statusTypes.indexOf('date'), 1);

      this.parentAnswers = $scope.ngDialogData.parentAnswers;

      if (this.parentAnswers && this.parentAnswers.length) {
        this.parentAnswers.forEach(parentAnswer => {
          parentAnswer.selected = false;
        });
      }

      var question = $scope.ngDialogData.question;

      if (
        question &&
        question.display_condition &&
        question.display_condition.options &&
        question.display_condition.options.length
      ) {
        question.display_condition.options.forEach(optionSelected => {
          if (this.parentAnswers && this.parentAnswers.length) {
            this.parentAnswers.forEach(parentAnswer => {
              if (optionSelected == parentAnswer.id) parentAnswer.selected = true;
            });
          }
        });
      }
    }

    comboOptions = [];

    replaceDotForDash(warning_level) {
      return this.Utils.replaceDotForDash(warning_level);
    }

    addHyperlink(url_to, url_text, url_data, isClinicLink) {
      if (this.LMNUK_1234) {
        const element = angular.element('[caret-handler]');
        const caretCtrl = element.controller('caretHandler');
        let position = caretCtrl.getCaretPositions();
        const TAG = isClinicLink ? 'LINK' : 'EXT_LINK';
        const currentText = this.$scope.ngDialogData.question.text;
        const link = `{{${TAG} to="${url_to}" text="${url_text}" data="${JSON.stringify(url_data)}"}}`;
        element.on('keyup mouseup', () => {
          position = caretCtrl.getCaretPositions();
        });
        if (currentText) {
          const textFirstHalf = currentText.substring(0, position.caretStart);
          const textSecondHalf = currentText.substring(position.caretEnd);
          const newText = textFirstHalf + link + textSecondHalf;
          this.$scope.ngDialogData.question.text = newText;
        } else {
          // start with empty string if text is undefined (bugfix)
          this.$scope.ngDialogData.question.text = '';
          this.$scope.ngDialogData.question.text += link;
        }
      } else {
        const TAG = isClinicLink ? 'LINK' : 'EXT_LINK';
        // TODO: ideally put this at the last carat position and not just at the end of the string
        this.$scope.ngDialogData.question.text += `{{${TAG} to="${url_to}" text="${url_text}" data="${JSON.stringify(url_data)}"}}`;
      }
    }

    save(question) {
      if (!question || !question.type) {
        this.toastr.warning('Please select a type');
        return;
      }

      if (!question || !question.text) {
        this.toastr.warning('Please enter a title');
        return;
      }

      if (!this.$scope.ngDialogData.isParentQuestion && (!this.answersSelected || !this.answersSelected.length)) {
        this.toastr.warning('Please select an answer');
        return;
      }

      if (this.answersSelected && this.answersSelected.length) {
        question.display_condition = {};
        question.display_condition.parent_question_id = this.$scope.ngDialogData.parentQuestion.id;
        question.display_condition.options = [];
        this.answersSelected.forEach(answerSelected => {
          question.display_condition.options.push(answerSelected.id);
        });
      } else {
        question.display_condition = null;
      }
      this.$scope.closeThisDialog({ newQuestion: question, comboOptions: this.comboOptions });
    }
  }

  QuestionController.$inject = ['$scope', '$timeout', 'toastr', 'Utils'];
  angular.module('pims').controller('QuestionController', QuestionController);
})();
